import { useCallback } from 'react';
import { useApiPost } from '@sierralabs/core-ui';
export function useCreateSiteRoute(siteId) {
    const { data, isLoading, error, post } = useApiPost(`sites/${siteId}/routes`);
    const createRoute = useCallback((name, path) => {
        post({
            name,
            path: `/${path
                .split('/')
                .filter(p => Boolean(p))
                .join('/')}`
        });
    }, [post]);
    return {
        createdRoute: data,
        creatingRoute: isLoading,
        createRouteError: error,
        createRoute
    };
}
//# sourceMappingURL=useCreateSiteRoute.js.map